import { FC, lazy } from 'react';
import { CapacityManagementRootRequest } from 'src/apis/capacity-management/use-capacity-management-root';
import { useUploads } from 'src/pages/reporting/products/uploaded/overview/use-uploads';
import { useUploadsParams } from 'src/pages/reporting/products/uploaded/overview/use-uploads-params';

const Page = lazy(() => import('./page'));

type Props = { capacityManagementRoot?: CapacityManagementRootRequest };

export const ReportingUploadsUploadedOverview: FC<Props> = ({
  capacityManagementRoot,
}) => {
  const pageParams = useUploadsParams();
  const uploads = useUploads({ params: pageParams.value });
  return (
    <Page
      pageParams={pageParams}
      uploads={uploads}
      capacityManagementRoot={capacityManagementRoot}
    />
  );
};
